import {
  Button,
  Card,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Modal,
  Row,
  Select,
  Space,
  Typography,
} from "antd";
import { useState } from "react";
import { PlusCircleOutlined, MinusCircleOutlined } from "@ant-design/icons";
import { actionForAddUpdateCeadVariationInformation } from "services/redux/cead/action";
import { useDispatch } from "react-redux";
import addCommaSeparator from "utils/inputCommaSeparator";
import commaSeparatorforList from "utils/commaSeparatorList";

const { Text, Title } = Typography;
const { Item, List } = Form;

export default function VariationForm({
  currencyOptions,
  formVariation,
  singleTenderCeadData,
}) {
  const dispatch = useDispatch();

  const handleVariationAmtChange = (index, name, form) => (e) => {
    const variationAmt = e.target.value?.replace(/,/g, "");

    const items = formVariation?.getFieldsValue().variation;

    const vatPer =
      formVariation?.getFieldsValue()?.variation?.[index]?.vatPercentage ?? 0;
    const cvExcAmt = variationAmt - (vatPer / 100) * variationAmt;
    const exclusions =
      formVariation?.getFieldsValue()?.variation?.[index]?.exclusions ?? 0;
    const feeableCv = cvExcAmt - exclusions;
    const feePercentage =
      formVariation?.getFieldsValue()?.variation?.[index]?.feePercentage ?? 0;
    const feeAmt = (feePercentage / 100) * feeableCv;
    const exchangeRate =
      formVariation?.getFieldsValue()?.variation?.[index]?.exchangeRate ?? 1;
    const equivalentNC = exchangeRate * feeAmt;

    items[index].variationAmount = commaSeparatorforList(e);
    items[index].cvExclVat = cvExcAmt.toLocaleString();
    items[index].feeableCv = feeableCv.toLocaleString();
    items[index].feeAmt = feeAmt.toLocaleString();
    items[index].equivalentNC = equivalentNC.toLocaleString();

    formVariation.setFieldsValue({
      variation: items,
    });
  };

  const handleVatPerChange = (index) => (e) => {
    const items = formVariation?.getFieldsValue().variation;
    const variationAmt = items[index].variationAmount.replace(/,/g, "");

    const vatPer = e.target.value;
    const cvExcAmt = variationAmt - (vatPer / 100) * variationAmt;
    const exclusions =
      formVariation?.getFieldsValue()?.variation?.[index]?.exclusions ?? 0;
    const feeableCv = cvExcAmt - exclusions;
    const feePercentage =
      formVariation?.getFieldsValue()?.variation?.[index]?.feePercentage ?? 0;
    const feeAmt = (feePercentage / 100) * feeableCv;
    const exchangeRate =
      formVariation?.getFieldsValue()?.variation?.[index]?.exchangeRate ?? 1;
    const equivalentNC = exchangeRate * feeAmt;

    items[index].cvExclVat = cvExcAmt.toLocaleString();
    items[index].feeableCv = feeableCv.toLocaleString();
    items[index].feeAmt = feeAmt.toLocaleString();
    items[index].equivalentNC = equivalentNC.toLocaleString();

    formVariation.setFieldsValue({
      variation: items,
    });
  };

  const handleExclusionChange = (index) => (e) => {
    const items = formVariation?.getFieldsValue().variation;

    const exclusionsValue = e.target.value.replace(/,/g, "");
    const cvExclVat = items[index].cvExclVat?.replace(/,/g, "");
    const feePercentage =
      formVariation?.getFieldsValue()?.variation?.[index]?.feePercentage ?? 0;
    const exchangeRate = items[index].exchangeRate ?? 0;
    const feeableCv = cvExclVat - exclusionsValue;
    const feeAmt = (feePercentage / 100) * feeableCv;
    const equivalentNC = exchangeRate * feeAmt;

    items[index].exclusions = commaSeparatorforList(e);
    items[index].feeableCv = feeableCv.toLocaleString();
    items[index].feeAmt = feeAmt.toLocaleString();
    items[index].equivalentNC = equivalentNC.toLocaleString();

    formVariation.setFieldsValue({
      variation: items,
    });
  };

  const handleFeePercentageChange = (index) => (e) => {
    const items = formVariation?.getFieldsValue().variation;

    const feePercentageValue = e.target.value;
    const feeableCv = items[index].feeableCv?.replace(/,/g, "");
    const feeAmt = (feePercentageValue / 100) * feeableCv;
    const exchangeRate =
      formVariation?.getFieldsValue()?.variation?.[index]?.exchangeRate ?? 0;
    const equivalentNC = exchangeRate * feeAmt;

    items[index].feeAmt = feeAmt.toLocaleString();
    items[index].equivalentNC = equivalentNC.toLocaleString();

    formVariation.setFieldsValue({
      variation: items,
    });
  };

  const handleExRateChange = (index) => (e) => {
    const items = formVariation?.getFieldsValue().variation;

    const exchangeRate = e.target.value;
    const feeAmt = items[index].feeAmt.replace(/,/g, "");
    const equivalentNC = feeAmt * exchangeRate;

    items[index].equivalentNC = equivalentNC.toLocaleString();

    formVariation.setFieldsValue({
      variation: items,
    });
  };

  const onFinishFormVariation = (values) => {
    let apiData = {
      variationDate: values?.variationDate,
      remarks: values.remarks,
      tenderCEADVariationInformationDtos: values?.variation,
    };

    dispatch(
      actionForAddUpdateCeadVariationInformation(
        apiData,
        singleTenderCeadData?.id,
        "CEADFinancialType=2"
      )
    );
  };

  return (
    <>
      <Card>
        <Form form={formVariation} onFinish={onFinishFormVariation}>
          <Item label="Date" name="variationDate">
            <DatePicker style={{ width: "250px", height: "30px" }} />
          </Item>
          <List name="variation">
            {(fields, { add, remove }) => (
              <>
                {fields.map((field, index) => (
                  <Row key={field.key} gutter={[10, 0]}>
                    <Col span={1}>{index + 1}</Col>

                    <Col span={2}>
                      <Item
                        key={field.key}
                        label="Currency"
                        name={[field.name, "currencyId"]}
                        fieldKey={[field.fieldKey, "currencyId"]}
                        rules={[
                          {
                            required: true,
                            message: "Currency is required",
                          },
                        ]}
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                      >
                        <Select
                          options={currencyOptions}
                          optionFilterProp="label"
                          placeholder="Select"
                          allowClear
                        />
                      </Item>
                    </Col>

                    <Col span={4}>
                      <Item
                        key={field.key}
                        label="Variation Amt"
                        name={[field.name, "variationAmount"]}
                        fieldKey={[field.fieldKey, "variationAmount"]}
                        rules={[
                          {
                            required: true,
                            message: "Variation Amt is required",
                          },
                        ]}
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                      >
                        <Input
                          placeholder="Enter ..."
                          onChange={handleVariationAmtChange(
                            index,
                            "variationAmount",
                            formVariation
                          )}
                        />
                      </Item>
                    </Col>

                    <Col span={2}>
                      <Item
                        key={field.key}
                        label="Vat %"
                        name={[field.name, "vatPercentage"]}
                        fieldKey={[field.fieldKey, "vatPercentage"]}
                        rules={[
                          {
                            required: true,
                            message: "Vat % is required",
                          },
                        ]}
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                      >
                        <Input
                          placeholder="Enter ..."
                          onChange={handleVatPerChange(index)}
                        />
                      </Item>
                    </Col>

                    <Col span={2}>
                      <Item
                        key={field.key}
                        label="CV Excl. Vat"
                        name={[field.name, "cvExclVat"]}
                        fieldKey={[field.fieldKey, "cvExclVat"]}
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                      >
                        <Input placeholder="Enter ..." />
                      </Item>
                    </Col>

                    <Col span={2}>
                      <Item
                        key={field.key}
                        label="Exclusions"
                        name={[field.name, "exclusions"]}
                        fieldKey={[field.fieldKey, "exclusions"]}
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                      >
                        <Input
                          placeholder="Enter ..."
                          onChange={handleExclusionChange(index)}
                        />
                      </Item>
                    </Col>

                    <Col span={2}>
                      <Item
                        key={field.key}
                        label="Fee'able CV"
                        name={[field.name, "feeableCv"]}
                        fieldKey={[field.fieldKey, "feeableCv"]}
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                      >
                        <Input placeholder="Enter ..." />
                      </Item>
                    </Col>

                    <Col span={2}>
                      <Item
                        key={field.key}
                        label="Fee %"
                        name={[field.name, "feePercentage"]}
                        fieldKey={[field.fieldKey, "feePercentage"]}
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                      >
                        <Input
                          placeholder="Enter ..."
                          onChange={handleFeePercentageChange(index)}
                        />
                      </Item>
                    </Col>

                    <Col span={2}>
                      <Item
                        key={field.key}
                        label="Fee Amt"
                        name={[field.name, "feeAmt"]}
                        fieldKey={[field.fieldKey, "feeAmt"]}
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                      >
                        <Input placeholder="Enter ..." />
                      </Item>
                    </Col>

                    <Col span={2}>
                      <Item
                        key={field.key}
                        label="Ex. Rate"
                        name={[field.name, "exchangeRate"]}
                        fieldKey={[field.fieldKey, "exchangeRate"]}
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                      >
                        <Input
                          placeholder="Enter ..."
                          onChange={handleExRateChange(index)}
                        />
                      </Item>
                    </Col>

                    <Col span={3}>
                      <Item
                        key={field.key}
                        label="EQ NC"
                        name={[field.name, "equivalentNC"]}
                        fieldKey={[field.fieldKey, "equivalentNC"]}
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                      >
                        <Input placeholder="Enter ..." />
                      </Item>
                    </Col>

                    <Col span={24}>
                      {index >= 0 && (
                        <Button
                          style={{ float: "right", marginTop: "-12px" }}
                          icon={<MinusCircleOutlined />}
                          onClick={() => remove(field.name)}
                        />
                      )}
                    </Col>
                  </Row>
                ))}
                <Button
                  style={{ marginBottom: "16px" }}
                  type="dashed"
                  onClick={() => add()}
                  block
                  icon={<PlusCircleOutlined />}
                >
                  Add Variation
                </Button>
              </>
            )}
          </List>

          <Item label="Remarks" name="remarks">
            <Input.TextArea />
          </Item>

          <Button
            type="primary"
            htmlType="submit"
            style={{ float: "right", marginTop: "5px" }}
          >
            Save
          </Button>
        </Form>
      </Card>
    </>
  );
}
